import React from "react";
import { Button, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import label from "../labels/common_en.json";
const Loader = () => {
  let loading = useSelector((state) => state.common.loading);
  return loading ? (
    <div className="appLoader">
      <Button variant="primary" disabled>
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      </Button>
      &nbsp;
      <Button variant="primary" disabled>
        <Spinner
          as="span"
          animation="grow"
          size="sm"
          role="status"
          aria-hidden="true"
        />
        &nbsp;{label.Loading}
      </Button>
    </div>
  ) : (
    ""
  );
};

export default Loader;
